import { render, staticRenderFns } from "./TreatmentSelection.vue?vue&type=template&id=55ceba84&scoped=true"
import script from "./TreatmentSelection.vue?vue&type=script&lang=js"
export * from "./TreatmentSelection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentSelection.vue?vue&type=style&index=0&id=55ceba84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ceba84",
  null
  
)

export default component.exports